<template>
  <div class="CalendarRescedule">
    <template>
      <div class="calendar">
        <sm-date-picker
          v-model="date_calendar"
          :min-date="new Date()"
          :disabled-dates="
            [
              { weekdays: [1] },
              id_jenis == 'paid_online'
                ? {
                    start:
                      this.dataRescedule.jadwal_ke == 'Jadwal Ke 1'
                        ? this.dataRescedule.jadwal_range
                        : null,
                    end:
                      this.dataRescedule.jadwal_ke == 'Jadwal Ke 1'
                        ? null
                        : this.dataRescedule.jadwal_range != ''
                        ? this.dataRescedule.jadwal_range
                        : alternatifData,
                  }
                : null,
            ].concat(Jadwal_Full)
          "
          :select-attribute="selectAttribute"
          @dayclick="onDayClick"
          is-expanded
          is-required
        />

        <hr class="m-t-32" />

        <div class="jadwal-info">
          <div class="p-x-20">
            <label class="f-14 f-c-midgrey f-Overpass remove-margin">
              Jadwal Training
            </label>
            <p class="f-Overpass f-16">
              {{ displayText }}
            </p>
          </div>
        </div>
      </div>
    </template>
    <template>
      <ModalScehedule ref="showJadwal" :paramsIdjenis="id_jenis" />
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "../store/state";

import ModalScehedule from "./ModalScehedule.vue";
export default {
  name: "CalendarRescedule",
  components: {
    ModalScehedule,
  },
  props: {
    Jadwal_Full: [],
    Jadwal_Exist: [],
    id_jenis: "",
  },
  data() {
    return {
      disabledDates: [],
      value: null,
      date_calendar: "",
      selectAttribute: {
        highlight: "green",
      },

      // ini digunakan agar di paid online, ketika user merefresh halaman nya itu tetap memilih tanggal
      // tetapi nanti akan terjadi error
      alternatifData: new Date(),
    };
  },
  computed: {
    ...mapGetters(moduleName, {
      dataRescedule: "dataRescedule",
      date_format: "date_format",
      dataJadwalUnavailable: "dataJadwalUnavailable",
    }),

    displayText() {
      if (
        this.date_format.toDisplay == "" ||
        this.dataRescedule.jadwal_mulai == ""
      ) {
        return "Belum Dipilih";
      } else {
        let tanggal = this.$moment(this.dataRescedule.jadwal_mulai).format(
          "DD MMMM YYYY"
        );
        let jamMulai = this.$moment(this.dataRescedule.jadwal_mulai).format(
          "HH:mm"
        );
        let jamSelesai = this.$moment(this.dataRescedule.jadwal_selesai).format(
          "HH:mm"
        );

        return `${tanggal} ${jamMulai} - ${jamSelesai}`;
      }
    },

    formatDateToChange() {
      return this.$moment(this.date_calendar).format("DD MMMM YYYY");
    },
    formatDateToPost() {
      return this.$moment(this.date_calendar).format("YYYY-MM-DD");
    },
  },

  methods: {
    ...mapActions({
      getDataTimeExist: `${moduleName}/getDataTimeExist`,
    }),

    showJadwal() {
      this.$refs.showJadwal.open();
    },

    async onDayClick() {
      if (this.date_calendar != "") {
        this.date_format.toPost = this.formatDateToPost;
        this.date_format.toDisplay = this.formatDateToChange;
      }

      if (this.date_format.toPost != "") {
        this.init();
        this.showJadwal();
        this.date_calendar = "";
      }
    },

    async init() {
      let Data = {
        idjenis: this.id_jenis,
        date: this.date_format.toPost,
      };
      await this.getDataTimeExist(Data);
    },
  },
};
</script>
